export const wait = async (cb, t) => {
    let [result] = await Promise.all([
        cb(),
        new Promise(rs => setTimeout(rs, t))
    ]);
    return result;
};
